import { Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { type MRT_ColumnDef, type MRT_RowData } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../../mantine/mrt/components/cell/MantineIconCell";
import { THEME_VARS } from "../../../../../../utils/constants";
import { getMeterTableErrorText } from "../getMeterTableErrorText";

export function getNameColumn<T extends MRT_RowData>(
  getCellError: (
    rowIndex: number,
    accessorKey: keyof T
  ) => Array<string> | null | undefined
): MRT_ColumnDef<T> {
  return {
    accessorKey: "name",
    header: "Was wird gemessen?",
    enableEditing: false,
    Cell: ({ row }) => {
      const cellError = getCellError(row.index, "name");
      return (
        <div>
          {row.original.name}
          {cellError && (
            <MantineIconCell
              iconColor={THEME_VARS.error[6]}
              IconComponent={IconAlertTriangle}
              renderedCellValue={
                <Text c="error">{getMeterTableErrorText(cellError[0])}</Text>
              }
            />
          )}
        </div>
      );
    }
  };
}
